export default __webpack_public_path__ + "images/968ca8270a36025f5006c1bec4333fdf-healthcare_small.webp";